var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14C8FF",
    d: "M18.227 8.901a1.88 1.88 0 0 1 .613 1.612l-.934 5.16a1.92 1.92 0 0 1-1.14 1.316l-5.088 1.782a2.03 2.03 0 0 1-1.753-.3l-4.152-3.368a1.87 1.87 0 0 1-.609-1.616l.93-5.16a1.92 1.92 0 0 1 1.14-1.316l5.092-1.782a2.03 2.03 0 0 1 1.748.3zm-4.329 2.242l.206-.857h-1.941l.274-1.715h-.626c-.454.695-1.114 1.415-1.886 1.715l-.175.857h1.118s-.381 1.35-.475 1.83c-.24 1.221.184 2.027 1.114 2.027h1.569l.197-.857h-1.316c-.583 0-.549-.322-.437-.887l.437-2.113z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.36a7ad3d996f31e09c2d4a2cb34621d9.svg";
export { ForwardRef as ReactComponent };